<div class="row">
  <div class="col-sm-12 col-lg-12 col-md-12">
    <!--collapsible panel bar goes here-->
    <kendo-panelbar #panelbar>
      <kendo-panelbar-item [title]="'SAMPLE SELECTION'"
                           [expanded]="true">
        <ng-template kendoPanelBarItemTitle>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!sampleItems.isSampleSelectionPanelValid && sampleItems.isContinueClicked"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="sampleItems.isSampleSelectionPanelValid && sampleItems.isContinueClicked"
                style="color:green;font-weight:600"></span>
        </ng-template>

        <ng-template kendoPanelBarContent>
          <form [formGroup]="sampleRequestForm" class="margin-10">

            <div class="row top">
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="lbl" [for]="finishCategoryLBL">{{sampleRequestLabel.finishCategory}}<span class="requiredField">*</span></label>
                  <kendo-dropdownlist class="kendoInput" #finishCategoryLBL
                                      formControlName="finishCategory"
                                      [data]="getFinishCategory"
                                      (valueChange)="categoryChange($event)"
                                      textField="category"
                                      valueField="finishSampleLevel1key" [ngClass]="{'borderRed':sampleItems.isEmptyFinishCategory && sampleItems.isSubmitted}" (blur)="validateSampleRequestForm()">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="col-sm-3">
                <div class="form-group">
                  <label class="lbl" [for]="finishLBL">{{sampleRequestLabel.finish}}<span class="requiredField">*</span></label>
                  <kendo-dropdownlist class="kendoInput" #finishLBL
                                      formControlName="finish"
                                      [data]="getFinish"
                                      textField="finish"
                                      (valueChange)="finishChange($event)"
                                      valueField="finishSampleLevel1key" [ngClass]="{'borderRed':sampleItems.isEmptyFinish && sampleItems.isSubmitted}" (blur)="validateSampleRequestForm()">
                  </kendo-dropdownlist>
                </div>
              </div>
              <div class="col-sm-1">
                <div class="form-group">
                  <label class="lbl" [for]="quantityLBL">{{sampleRequestLabel.quantity}}<span class="requiredField">*</span></label>
                  <kendo-numerictextbox formControlName="quantity" #quantityLBL [autoCorrect]="true" [format]="'n0'"
                                        [min]="1" max="{{maxQuantity}}" id="qty" [ngClass]="{'borderRed':sampleItems.isEmptyQuantity && sampleItems.isSubmitted}" (blur)="validateSampleRequestForm()">
                  </kendo-numerictextbox>
                  <!-- <span class="leftStyle">min=1, max=50</span>-->
                </div>
              </div>
              <div class="col-sm-2">
                <button kendoButton primary="true" class="m-3" (click)="addSelection()">
                  Add Selection
                </button>
              </div>
              <div class="col-sm-2">
                <button kendoButton primary="true" class="m-3" (click)="clearSelection()">
                  Clear Selection
                </button>
              </div>
              <div class="col-sm-1">               
              </div>
            </div>
          </form>
          <br />
          <section class="margin-10">
            <kendo-grid [data]="sampleRequestGridView"
                        [height]="470"
                        [sortable]="true"
                        [navigable]="true"
                        [filterable]="true"
                        [groupable]="false"
                        [reorderable]="true"
                        [resizable]="false"
                        [sort]="sampleRequestGridstate.sort"
                        (sortChange)="sampleRequestGridSortChange($event)"
                        [pageable]="{ buttonCount: 5, info: true }"
                        [pageSize]="sampleRequestGridstate.take"
                        [skip]="sampleRequestGridstate.skip"
                        [columnMenu]="false"
                        (pageChange)="sampleRequestGridPageChange($event)"
                        (dataStateChange)="sampleRequestDataStateChange($event)"
                        [filter]="sampleRequestGridstate.filter"
                        [loading]="sampleRequestLoading">

              <kendo-grid-column field="" title="Image"
                                 [width]="150">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <img src="../../assets/images/Advance-Search/027010_S.gif" alt="" />
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="category" title="{{sampleRequestLabel.finishCategory}}"
                                 [filterable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="finish" title="{{sampleRequestLabel.finish}}"
                                 [filterable]="true">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-column field="quantity" title="{{sampleRequestLabel.quantity}}"
                                 [filterable]="true" [width]="150">
                <ng-template kendoGridFilterCellTemplate let-filter let-column="column">
                  <kendo-grid-string-filter-cell [column]="column" [filter]="filter">
                    <kendo-filter-contains-operator></kendo-filter-contains-operator>
                  </kendo-grid-string-filter-cell>
                </ng-template>
              </kendo-grid-column>
              <kendo-grid-command-column [width]="80"
                                         [headerStyle]="{'background-color': '#d3d3d3', 'border-color': 'rgba(0,0,0,0)'}"
                                         [footerStyle]="{'border-color': 'rgba(0,0,0,0)'}">
                <ng-template kendoGridCellTemplate class="d-super-center" let-dataItem let-rowIndex="rowIndex">
                  <button class="k-button k-grid-remove-command " (click)="deleteSample(rowIndex)">
                    <span class="k-icon k-i-trash">
                    </span>
                  </button>
                </ng-template>
              </kendo-grid-command-column>
              <ng-template kendoPagerTemplate let-totalPages="totalPages" let-currentPage="currentPage">
                <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                <kendo-pager-numeric-buttons [buttonCount]="5"></kendo-pager-numeric-buttons>
                <kendo-pager-info></kendo-pager-info>
                <kendo-pager-next-buttons></kendo-pager-next-buttons>
                <kendo-pager-page-sizes [pageSizes]="[50,75,100]"></kendo-pager-page-sizes>
              </ng-template>
            </kendo-grid>
          </section>
          <div class="row">
            <div class="col-12 center">
              <button kendoButton primary="true" class="m-3" (click)="continueToAddressPanel()">
                Continue
              </button>
            </div>
          </div>

        </ng-template>
      </kendo-panelbar-item>
      <kendo-panelbar-item [title]="'SHIPPING DETAILS'"
                           [expanded]="false">
        <ng-template kendoPanelBarItemTitle>
          <span class="k-icon k-i-cancel" style="color:red;font-weight:300"
                *ngIf="!shippingDetails.isShippingDetailsPanelValid && shippingDetails.isSubmitted"></span>
          <span class="k-icon k-i-check-circle k-i-checkmark-circle"
                *ngIf="shippingDetails.isShippingDetailsPanelValid && shippingDetails.isSubmitted"
                style="color:green;font-weight:600"></span>
        </ng-template>
        <ng-template kendoPanelBarContent>
          <form [formGroup]="shippingDetailsForm">
            <div class="row top">
              <div class="col-sm-2"></div>
              <div class="col-sm-8">
                <div class="row">
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.companyName}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="companyName"
                             class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyCompanyName && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.addressLine1}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="addressLine1"
                             class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyAddress1 && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.city}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="city"
                             class="kendoInput" [ngClass]="{'borderRed':shippingDetails.isEmptyCity && shippingDetails.isSubmitted}" (blur)="validateShippingDetailsForm()" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.state}}<span class="requiredField">*</span></label>
                      <kendo-dropdownlist class="kendoInput"
                                          formControlName="state"
                                          [ngModel]="{stateDescription:selectedState,stateCode:selectedState}"
                                          [data]="getState"
                                          [textField]="'stateDescription'"
                                          [valueField]="'stateCode'" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyState && shippingDetails.isSubmitted}">
                      </kendo-dropdownlist>
                    </div>
                  </div>
                  <div class="col-sm-6">
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.jobName}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="jobName"
                             class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyJobName && shippingDetails.isSubmitted}" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.addressLine2}}</label>
                      <input type="text" kendoTextBox formControlName="addressLine2"
                             class="kendoInput" />
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.phoneNumber}}<span class="requiredField">*</span></label>
                      <kendo-numerictextbox formControlName="phoneNumber" [maxlength]="10"
                                            [format]="'#'" [spinners]="false"
                                            class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':(shippingDetails.isEmptyPhoneNumber || shippingDetails.isInvalidPhoneNumber) && shippingDetails.isSubmitted}"></kendo-numerictextbox>
                      <span title="Phone number length should be minimum 10"
                            *ngIf="shippingDetails.isInvalidPhoneNumber" kendoTooltip
                            class="k-icon k-i-information k-i-info spanInfoIconCls"></span>
                    </div>
                    <div class="form-group">
                      <label class="lbl">{{shippingDetails.zipCode}}<span class="requiredField">*</span></label>
                      <input type="text" kendoTextBox formControlName="zipCode"
                             class="kendoInput" (blur)="validateShippingDetailsForm()" [ngClass]="{'borderRed':shippingDetails.isEmptyZipCode && shippingDetails.isSubmitted}" />
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xs-12 col-sm-12">*{{shippingDetails.info1}}</div>
                  <div class="col-xs-12 col-sm-12">**{{shippingDetails?.info2}}</div>
                </div>
                <div class="col-12 center">
                  <button kendoButton class="m-3" (click)="cancel()">
                    Cancel
                  </button>
                  <button kendoButton class="m-3 btn btn-success" (click)="placeOrder()" [disabled]="saveInProcess">
                    Place Order <kendo-loader *ngIf="saveInProcess" style="color:blue"></kendo-loader>
                  </button>
                </div>
              </div>
              <div class="col-sm-2"></div>
            </div>
          </form>

        </ng-template>
      </kendo-panelbar-item>


    </kendo-panelbar>
  </div>
  <section>
    <kendo-dialog [minWidth]="200" [minHeight]="100" title="Sample Request" *ngIf="confirmDialogOpened" (close)="confirmDialogClose()">
        Your Sample request order has been placed successfully.        
    </kendo-dialog>
  </section>
</div>
